import type { StyleElements } from "replo-runtime/shared/utils/styles";
import type { CustomPropsRecord } from "schemas/component";
import type { ComponentConfig } from "../../components";

function getConfigurableProps(): CustomPropsRecord {
  return {
    _rating: {
      name: "Rating",
      type: "ratingBalancer",
      description:
        "Rating value out of the total number of stars (e.g. for 4/5, this is 4)",
      defaultValue: 5,
    },
    _totalStars: {
      name: "Total Stars",
      type: "integer",
      description: "Total number of possible stars (e.g. for 4/5, this is 5)",
      defaultValue: 5,
    },
    _starColor: {
      name: "Color",
      type: "color",
      description: "Color of the Stars",
      defaultValue: "#000000",
    },
    _size: {
      name: "Size",
      type: "pixels",
      description: "Size of each star",
      defaultValue: "16px",
    },
    _accessibilityHidden: {
      type: "boolean",
      name: "Accessibility Hidden",
      description:
        "If set, removes this component from the accessibility tree, hiding it from screen readers.",
      defaultValue: null,
    },
    _accessibilityLabelledBy: {
      type: "selectable",
      name: "Accessibility Labelled By",
      description:
        "If you select a Text component here, the Text component will be used to label this component in accessibility controls.",
      defaultValue: null,
      placeholder: "Select a component",
    },
    _accessibilityLabel: {
      type: "string",
      name: "Accessibility Label",
      description:
        "If provided, this will be used as the aria-label for this component.",
      defaultValue: undefined,
    },
  };
}

const styleElements = {
  root: {},
  icon: {
    overrideStyles({ component }) {
      const size = component.props._size;
      const starColor = component.props._starColor;
      return {
        width: size,
        height: size,
        fill: starColor,
      };
    },
  },
} as const satisfies StyleElements;

const config = {
  renderData: {
    newInstancesUseNumbering: true,
    allowsLayoutModification: true,
    acceptsArbitraryChildren: () => false,
    isAlwaysDynamic: true,
    customProps: Object.entries(getConfigurableProps()).map(([key, value]) => {
      return {
        ...value,
        id: key,
        name: value.name,
      };
    }),
    canvasIndicatorDragDirections: [],
    canContainChildren: false,
    styleElements,
    showAccessibilityMenu: true,
  },
} satisfies ComponentConfig;

export default config;
